import React from 'react'
import InlinePreloader from '../InlinePreloader'

const FormButton = ({buttonLabel, buttonAction, processing}) => {
  return (
    <button type='submit' disabled={processing} onClick={()=>{buttonAction()}} className='w-full p-3 rounded bg-vcm-purple text-purple-200 border border-vcm-purple text-md transition duration-200 hover:bg-vcm-light-purple hover:text-vcm-purple flex items-center justify-center'>{processing ? <InlinePreloader /> : buttonLabel }</button>
  )
}

export default FormButton